import { createLocation } from 'history'

import { getAbsoluteRoute, getContext, type RouteParentPath } from './Config'
import type {
    AbsoluteRoutePathWithId,
    AbsoluteRoutePathWithServiceAndResourceId,
    AbsoluteRoutePathWithServiceId,
    AbsoluteRouteUpdateArgs,
    RelativeRoutePathWithId,
    RouteUpdateArgs,
} from './Domain'
import { useRouting } from './Hook.ExternalRouting'

export const useInternalRoutingHook = useRouting.extend(
    (RoutingHook) =>
        class extends RoutingHook {
            getAbsoluteRoute (
                relativePath: RelativeRoutePathWithId
            ): AbsoluteRoutePathWithServiceId | AbsoluteRoutePathWithId | AbsoluteRoutePathWithServiceAndResourceId {
                return getAbsoluteRoute(relativePath, getContext(this.state.path))
            }

            override getParentAbsoluteRouteUpdateArgs (parent: RouteParentPath): AbsoluteRouteUpdateArgs {
                return super.getParentAbsoluteRouteUpdateArgs(parent)
            }

            createHref (...args: RouteUpdateArgs): string {
                return this.history.createHref(createLocation(this.generateRedirectionPath(...args)))
            }
        },
    'useInternalRoutingHook'
)
